import React, { Component } from 'react';
import { Button, DatePicker, Input, Select, Icon } from "antd";
import moment from "moment";
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import SelectProvince from '../../common/SelectProvince';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import SearchMulRetrieve from '../../common/SearchMulRetrieve';

const { Option } = Select;
const InputGroup = Input.Group;
const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';
const { MonthPicker } = DatePicker;
const roleList = [
    { label: 'PM', value: 'PM' },
    { label: 'PA', value: 'PA' },
    { label: 'CRC', value: 'CRC' },
    { label: 'CRCC', value: 'CRCC' },
    { label: 'CRCM', value: 'CRCM' },
    { label: 'PML', value: 'PML' },
];

class Filter extends Component {
    state = {
        businessList: [],
        areaList: [],
        expand: false,
    }

    componentDidMount() {
        this.getDepartmentList();
        this.queryWithLevelByParams('LINE_OF_BUSINESS');
        this.loadTypeConfigureList();
    }

    getDepartmentList = () => {
        const options = {
            url: API_URL.manhour.queryManHourRecordDepartment,
            data: { isFilter: 1 },
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ departmentList: res.data });
            }),
        };
        $.sendRequest(options);
    }

    queryWithLevelByParams = (typeName) => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { typeConfigureList } = res;
            this.setState({ businessList: typeConfigureList || [] });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.areaList });
        });
    }
    
    search = () => {
        this.props.search();
    }

    export = () => {
        this.props.export();
    }

    exportData = () => {
        this.props.exportData();
    }
    
    saveProvince = (checkedArea) => {
        const { searchParams, onChange } = this.props;
        const areaParams = {};
        const areaList = [];
        const hasCheckedArea = [];
        checkedArea.forEach(item => {
            const { key, props } = item;
            hasCheckedArea.push(key);
            areaList.push(props.title);
            areaParams[`params[${props.title}]`] = key;
        });
        onChange({
            ...searchParams,
            areaParams,
            hasCheckedArea,
            areaName: areaList.join(),
        });
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'enterpriseDepartmentId': {
                const { departmentList = [] } = this.state;
                searchParams[key] = value;
                searchParams.enterpriseDepartmentName = (departmentList.find(i => i.enterpriseDepartmentId == value) || {}).enterpriseDepartmentName;
                searchParams.positionIds = '';
                onChange(searchParams);
                break;
            }
            case 'lineOfBusinessIds':
                searchParams[key] = value ? value.join(',') : undefined;
                searchParams.secondLineName = undefined;
                onChange(searchParams);
                break;
            case 'investigationAreaId':
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                searchParams.diseaseName = undefined;
                onChange(searchParams);
                break;
            case 'disease':
            case 'leader':
            case 'hospital': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    handleSearchChange = (value, option, key) => {
        const { searchParams, onChange } = this.props;
        let list = searchParams[key] ? searchParams[key].split(',') : [];
        if (option) {
            list.push(option.value);
        } else {
            list = list.filter(i => i != value);
        }
        searchParams[key] = list.join(',');
        onChange(searchParams);
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render() {
        const { positionRole }= sessionStorage;
        const allowedRoles = ['CTA', 'VP', 'BO', 'FIN', 'HRRC'];
        const isAllowedRole = allowedRoles.includes(positionRole);
        const {  searchParams } = this.props;
        const { departmentList = [], expand, businessList, areaList } = this.state;
        const { startDate, endDate, enterpriseDepartmentId, positionIds, status,
            oper, leftTime, lineOfBusinessIds, areaName, hasCheckedArea = [] } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            const arr = (lineOfBusinessIds || '').split(',');
            if (arr.some(j => j == i.typeConfigureId)) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const departmentOptions = departmentList.map(d => <Option key={d.enterpriseDepartmentId}>{d.enterpriseDepartmentName}</Option>);
        const businessOption = businessList.map(d => <Option key={d.typeConfigureId} title={d.typeValue}>{d.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(d => <Option key={d} title={d}>{d}</Option>);
        const areaListOption = areaList.map(d => <Option key={String(d.investigationAreaId)} title={d.investigationAreaName}>{d.investigationAreaName}</Option>);
        const roleOption = roleList.map(d => <Option key={d.value}>{d.label}</Option>);
        return (
            <div style={{marginBottom: 16}}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    <div className="expand-box" style={{ right: 25 }}>
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <MonthPicker
                            style={{width: 100}}
                            format={monthFormat}
                            placeholder="请选择"
                            onChange={(date, dateString) => this.handleChange(dateString, 'startDate')}
                            allowClear={false}
                            value={startDate ? moment(startDate) : null}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">至</label>
                        <MonthPicker
                            style={{width: 100}}
                            format={monthFormat}
                            placeholder="请选择"
                            onChange={(date, dateString) => this.handleChange(dateString, 'endDate')}
                            allowClear={false}
                            value={endDate ? moment(endDate) : null}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">员工</label>
                        <Input
                            style={{width: 100}}
                            placeholder="请输入"
                            value={searchParams.codeName}
                            onChange={e => this.handleChange(e.target.value, 'codeName')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">区域/城市</label>
                        <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">汇报线</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 120 }}
                            value={searchParams.leadType}
                            onChange={value => this.handleChange(value, 'leadType')}
                        >
                            <Option value="SYNCHRONIZE">实际汇报线</Option>
                            <Option value="SYSTEM">虚拟汇报线</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">所属部门</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 180 }}
                            value={enterpriseDepartmentId}
                            onChange={value => this.handleChange(value, 'enterpriseDepartmentId')}
                        >
                            { departmentOptions }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">职位</label>
                        <SearchMulRetrieve
                            keyword="positionName"
                            placeholder="输入职位自动检索"
                            style={{width: 200}}
                            disabled={!enterpriseDepartmentId}
                            value={positionIds ? positionIds.split(',') : []}
                            // 仅有恢复的已选值时挂载即查（用于回显名称标签），全新进入空值不发
                            shouldSearch={!!positionIds}
                            params={{limit: 20, enterpriseDepartmentId}}
                            url={API_URL.team.queryUserPositionSelect}
                            config={{ id: 'positionId', name: 'positionName' }}
                            onChange={(value, option) => this.handleSearchChange(value, option, 'positionIds')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">直线主管</label>
                        <SearchRetrieve
                            keyword='userNameCode'
                            style={{ width: 150 }}
                            placeholder="输入工号或姓名检索"
                            url={API_URL.team.querySynchronizeLowerUserList}
                            value={searchParams.leaderName}
                            config={{ id: 'userId', name: 'name', code: 'employeeCode', show: 'user', type: 'leader' }}
                            onChange={(option) => this.handleChange(option, 'leader')}
                        />
                    </div>
                    <div className="search-item">
                            <label htmlFor="" className="ui-label">目前状态</label>
                            <Select
                                placeholder="请选择"
                                value={searchParams.status}
                                onChange={value => this.handleChange(value, 'status')}
                                style={{width:90}}
                                allowClear={true}
                            >
                                <Option value="WORKING">在职</Option>
                                <Option value="LEFT">离职</Option>
                            </Select>
                    </div>
                    <div className="search-item">
                            <label htmlFor="" className="ui-label">离职日期</label>
                            <InputGroup compact>
                                <Select value={oper} onChange={value => this.handleChange(value, 'oper')}>
                                    <Option value="GT">&gt;</Option>
                                    <Option value="GE">&ge;</Option>
                                    <Option value="LT">&lt;</Option>
                                    <Option value="LE">&le;</Option>
                                    <Option value="EQ">=</Option>
                                </Select>
                                <DatePicker
                                    format={dateFormat}
                                    placeholder="请选择"
                                    disabled={status !== 'LEFT'}
                                    value={leftTime ? moment(leftTime) : null}
                                    onChange={(date, dateString) => this.handleChange(dateString, 'leftTime')}
                                    allowClear={true}
                                />
                            </InputGroup>
                    </div>
                    <div className="search-item" style={{ height: 30 }}>
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            filterOption={false}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusinessIds ? lineOfBusinessIds.split(',') : []}
                            className="multiple-stage"
                            onChange={value => this.handleChange(value, 'lineOfBusinessIds')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusinessIds}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目领域</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            value={searchParams.investigationAreaId}
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaListOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">疾病</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 140 }}
                            params={{ investigationAreaId: searchParams.investigationAreaId }}
                            placeholder="输入名称检索"
                            url={API_URL.common.queryAllDisease}
                            value={searchParams.diseaseName}
                            config={{ id: 'diseaseId', name: 'diseaseName' }}
                            onChange={(option) => this.handleChange(option, 'disease')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">中心</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 180 }}
                            params={{ invId: 0 }}
                            placeholder="输入中心/编号检索"
                            url={API_URL.manhour.queryManHourHospital}
                            value={searchParams.hospitalName}
                            config={{ id: 'hospitalId', name: 'hospitalName' }}
                            onChange={(option) => this.handleChange(option, 'hospital')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">角色</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            value={searchParams.roleCode}
                            style={{ width: 80 }}
                            onChange={value => this.handleChange(value, 'roleCode')}
                        >
                            {roleOption}
                        </Select>
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button className="btn" type="primary" onClick={this.search}>搜索</Button>
                        <Button className="btn" type="primary" onClick={this.export}>导出</Button>
                        {isAllowedRole && <Button className="btn" type="primary" onClick={this.exportData}>导出固化数据</Button>}
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/manHour/query/Filter.js